import React from "react";
// import DoctorWithStetoscope from '../assets/DoctorWithStetoscope.png';
import nurse from "../assets/men 1.png";
import done from "../assets/Done.png";

const ProfesionalValue = () => {
  return (
    // <div className="bg-[#FFFBFB] lg:h-[500px] h-[600px] flex items-center">
    //   <div className="flex lg:flex-row flex-col mx-auto w-10/12 justify-center items-center gap-3">
    //     <div className="lg:w-6/12 w-11/12">
    //       <img
    //         src={DoctorWithStetoscope}
    //         alt="DoctorWithStetoscope"
    //         className="lg:h-[350px]"
    //       />
    //     </div>
    //     <div className="p-6 lg:w-5/12 w-11/12">
    //       <p className="font-bold text-center md:text-left lg:text-[35px] text-[22px]">
    //         We deliver <span className="underline">professional</span>
    //         <span className='md:inline'>
    //         <br />
    //            value for your operating teams
    //         </span>
    //       </p>
    //       <p className="mt-5 text-center md:text-left text-[20px]">
    //         <span className="font-bold text-[20px]">For every order placed. </span>
    //         healthcare professionals
    //          can enjoy incentives, career development, recognition,
    //         driving safety rewards, social media mentions, and access to
    //         valuable resources.
    //       </p>
    //     </div>
    //   </div>
    // </div>
    <>
    <div className="flex flex-col  md:flex-row justify-evenly items-center p-5" id="why-us">
      <div className="">
        <div className="flex flex-col justify-start items-center md:items-start md:gap-10">
          <p className="text-[30px] mb-0 leading-10 md:text-3.5xl font-lato font-extrabold mb-5">
            <strong>
              
              
              <span className="underline text-[#B70303]">
                Valuable Support
                </span>
                
              
              <span className="ml-4">for</span>
              <br className="" />
                your hospital staff
            </strong>
          </p>

          <p className="font-lato text-[18px] mb-5 text-center md:text-left md:text-[25px] md-leading-15 md:mb-10">
            For every order placed, your healthcare workers{" "}
            <br className="hidden md:inline" />
            can enjoy incentives, recognition, safety rewards,{" "}
            <br className="hidden md:inline" />
            and access to valuable resources.
          </p>
        </div>

        <div className="flex justify-center md:justify-start gap-2 mt-5">
          <div className="flex flex-col font-bold justify-evenly whitespace-nowrap">
            <div className="mb-3">
              {" "}
              <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                <img src={done} alt="" />
              </div>
              <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                Recognition & Bonuses
              </p>
            </div>
            <div className="gap-3">
              {" "}
              <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                <img src={done} alt="" />
              </div>
              <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                Safety Perks
              </p>
            </div>
          </div>

          <div className="flex flex-col font-bold justify-evenly whitespace-nowrap">
            <div className="mb-3">
              {" "}
              <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                <img src={done} alt="" />
              </div>
              <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                Access Valued Resources
              </p>
            </div>
            <div className="gap-3">
              {" "}
              <div className="bg-red-200 absolute w-[20px] md:w-[25px]">
                <img src={done} alt="" />
              </div>
              <p className="relative ml-6 font-lato text-[14px] md:text-lg md:ml-10">
                Career Support
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 md:mb-0">
        <img src={nurse} alt="nerve" className="md:w-[80%] lg:w-[580px] lg:h-[600px] lg:p-3 object-cover" />
      </div>
    </div>
  </>
  );
};

export default ProfesionalValue;
